var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfoWarn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D97706",
    d: "M10.996 20c-4.964 0-9.002-4.039-9.002-9.003s4.038-9.003 9.002-9.003S20 6.032 20 10.996C20 15.961 15.96 20 10.996 20Zm0 1C16.521 21 21 16.521 21 10.996 21 5.472 16.521.993 10.996.993 5.472.993.993 5.472.993 10.996.993 16.521 5.472 21 10.996 21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D97706",
    d: "M10.01 15.089a.987.987 0 1 1 1.975 0 .987.987 0 0 1-1.975 0ZM11.701 12.758h-1.4V5.922h1.4v6.836Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoWarn);
export default __webpack_public_path__ + "static/media/icon-info-warn.0968e4f95c5d52f32e4742998e5e0db6.svg";
export { ForwardRef as ReactComponent };